const getters = {
  // 默认配置
  leftToolType: (state) => state.defaultInfo.leftToolType,
  sid: (state) => state.defaultInfo.sid,
  isCheck: (state) => state.defaultInfo.isCheck,
  firstInit:  (state) => state.defaultInfo.firstInit,
  isShowMix: (state) => state.defaultInfo.isShowMix,
  ccWebsocketClient: (state) => state.defaultInfo.ccWebsocketClient,
  userInfo: (state) => state.defaultInfo.userInfo,
  chatRoomId: (state) => state.defaultInfo.chatRoomId,
  shareType: (state) => state.defaultInfo.shareType,
  isPackUp: (state) => state.defaultInfo.isPackUp,

  isShowAsideTool: (state) => state.defaultInfo.isShowAsideTool,
  isShowSign: (state) => state.defaultInfo.isShowSign,
  isShowLuck: (state) => state.defaultInfo.isShowLuck,
  isShowPasswordLuck: (state) => state.defaultInfo.isShowPasswordLuck,
  isShowCurt: (state) => state.defaultInfo.isShowCurt,
  isShowGroup: (state) => state.defaultInfo.isShowGroup,
  isShowPseudo: (state) => state.defaultInfo.isShowPseudo,
  isShowAnswer: (state) => state.defaultInfo.isShowAnswer,
  isShowAnswerSheet: (state) => state.defaultInfo.isShowAnswerSheet,
  isShowGoods: (state) => state.defaultInfo.isShowGoods,
  isShowRecommend: (state) => state.defaultInfo.isShowRecommend,
  isShowCountDown: (state) => state.defaultInfo.isShowCountDown,
  isShowRedPacket: (state) => state.defaultInfo.isShowRedPacket,
  isShowRedPacketRecord: (state) => state.defaultInfo.isShowRedPacketRecord,
  isShowRedPacketDetail: (state) => state.defaultInfo.isShowRedPacketDetail,
  isShowCement: (state) => state.defaultInfo.isShowCement,
  isChangeArea: (state) => state.defaultInfo.isChangeArea,
  signalStatus: (state) => state.defaultInfo.signalStatus,
  loginPageBackground: (state) => state.defaultInfo.loginPageBackground,
  loginPageLogo: (state) => state.defaultInfo.loginPageLogo,
  // 会议相关
  rtcClient: (state) => state.meetInfo.rtcClient,

  VideoInputDeviceId: (state) => state.meetInfo.VideoInputDeviceId,
  AudioInputDeviceId: (state) => state.meetInfo.AudioInputDeviceId,
  AudioOutputDeviceId: (state) => state.meetInfo.AudioOutputDeviceId,
  meetStatusInfo: (state) => state.meetInfo.meetStatusInfo,
  JoinedList: (state) => state.meetInfo.JoinedList,

  layoutData: (state) => state.meetInfo.layoutData,

  selfAudioStatus: (state) => state.meetInfo.selfAudioStatus,
  selfVideoStatus: (state) => state.meetInfo.selfVideoStatus,
  selfParticipant: (state) => state.meetInfo.selfParticipant,
  roomId: (state) => state.meetInfo.roomId,
  groupInfo: (state) => state.meetInfo.groupInfo,
  //直播相关
  chatImages: (state) => state.liveInfo.chatImages,
  liveToken: (state) => state.liveInfo.liveToken,
  liveId: (state) => state.liveInfo.liveId,
  liveConfig: (state) => state.liveInfo.liveConfig,
  defaultSource: (state) => state.liveInfo.defaultSource,
  liveRoomType: (state) => state.liveInfo.liveRoomType,
  controlLiveConfig: (state) => state.liveInfo.controlLiveConfig,
  liveCid: (state) => state.liveInfo.liveCid,
  liveTitle: (state) => state.liveInfo.liveTitle,
  liveLogo: (state) => state.liveInfo.liveLogo,
  playerUrl: (state) => state.liveInfo.playerUrl,
  userRole: (state) => state.liveInfo.userRole,
  meetStatus: (state) => state.liveInfo.meetStatus,
  assistantStatus: (state) => state.liveInfo.assistantStatus,
  liveRoomStatus: (state) => state.liveInfo.liveRoomStatus,
  voipInfo: (state) => state.liveInfo.voipInfo,
  isVoipName: (state) => state.liveInfo.isVoipName,
  pushStreamStatus: (state) => state.liveInfo.pushStreamStatus,
  liveStartTime: (state) => state.liveInfo.liveStartTime,
  recordStatus: (state) => state.liveInfo.recordStatus,
  all_user_online_count: (state) => state.liveInfo.all_user_online_count,
  guestSeeAuth: (state) => state.liveInfo.guestSeeAuth,
  rewardCount: (state) => state.liveInfo.rewardCount,
  praiseCount: (state) => state.liveInfo.praiseCount,
  liveSubscription: (state) => state.meetInfo.liveSubscription,
  thirdPushStreamStatus: (state) => state.liveInfo.thirdPushStreamStatus,
  autoRecording: (state) => state.liveInfo.autoRecording,
  audit: (state) => state.liveInfo.audit,
  opType: (state) => state.liveInfo.opType,
  streamStatus: (state) => state.liveInfo.streamStatus,
  used: (state) => state.liveInfo.used,
  tophighlight: (state) => state.liveInfo.tophighlight,
  isLeave: (state) => state.defaultInfo.isLeave,
  logInfo: (state) => state.defaultInfo.logInfo, //日志信息
  contract: (state) => state.defaultInfo.contract, //日志信息
  pseudoLiveInfo: (state) => state.liveInfo.pseudoLiveInfo,
  confId: (state) => state.liveInfo.confId, // 直播场次id
  setting: state => state.defaultInfo.setting,
  authCheckToken: state => state.liveInfo.authCheckToken,
  userNumber: state => state.liveInfo.userNumber,
  isCustomerService: state => state.liveInfo.is_customer_service,
  mediaStatus: state => state.liveInfo.medaiStatus,
  //分组相关
  teamId:state => state.defaultInfo.teamId,
  groupOrder: state => state.defaultInfo.groupOrder,
  hostUsersDuration: state => state.liveInfo.hostUsersDuration,
  mainStatusKey: state => `switch:main:status:${state.defaultInfo?.userInfo?.uid}`,
  micDefault: state => state.liveInfo.micDefault,
  qaEnabled: state => state.liveInfo.qaEnabled,
  recordStartTime: state => state.liveInfo.recordStartTime,
  //摄像头分辨率
  cameraResolution: state => state.liveInfo.cameraResolution,
  videoWall: state => state.liveInfo.videoWall,
  hostSkin: state => state.liveInfo.hostSkin,
  audience: state => state.liveInfo.audience,
  audioAudit: state => state.liveInfo.audioAudit,
  inputInstant: state => state.defaultInfo.inputInstant,
  ischangeVideo: state => state.defaultInfo.ischangeVideo
};
export default getters;
